module.exports = __webpack_public_path__ + "static/media/question.3070b932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/question.svg
// module id = 281
// module chunks = 36